export const initialValues = {
  step1: {
    section1: {
      ownerType: '',
      buildingOwners: [],
      ein: '',
      duns: '',
      streetAddress: '',
      city: '',
      state: '',
      zipCode: '',
      phone: '',
      fax: '',
      email: '',
      hasContactName: false,
      additionalName: '',
      hasAdditionalAddress: false,
      additionalAddress: '',
    },
    section2: {
      streetAddress: '',
      city: 'Birmingham',
      state: 'Alabama',
      zipCode: '',
      buildingCount: undefined,
      currentUsage: '',
      zoning: '',
    },
  },
  step2: {
    section1: [],
    section2: [],
  },
  step3: {
    projectDescription: '',
    beginDate: '',
    completionDate: '',
    hasPortion: '',
    portionDescription: '',
    section2: [],
  },
  step4: {
    section1: {
      createNewJob: '',
      jobClassification: [],
      willResultRhu: '',
      rhuCount: undefined,
      affordableHousing: '',
      ahCount: undefined,
    },
    section2: {
      description1: '',
      description2: '',
      description3: '',
    },
    section3: {
      q1: '',
      q2: '',
      q3: '',
      q4: '',
      q5: '',
    },
    section4: {
      advDisadvantagedBusiness: '',
      description: '',
    },
  },
  step5: {
    f1: {
      selectedFiles: [],
      haveFiles: false,
      haveFilesDescription: '',
    },
    f2: {
      selectedFiles: [],
      haveFiles: false,
      haveFilesDescription: '',
    },
    f3: {
      selectedFiles: [],
      haveFiles: false,
      haveFilesDescription: '',
    },
    f4: {
      selectedFiles: [],
      haveFiles: false,
      haveFilesDescription: '',
    },
  },
  step6: {
    printName: '',
    applicantTitle: '',
  },
};
